import type { ImpressionViewAncillariesItem } from '@/scopes/checkout/domain/analytics/types'

export const roomSelectionTypeRadioGroupOptions = ['specific', 'random'] as const
export type RoomSelectionTypeRadioGroupOptions = (typeof roomSelectionTypeRadioGroupOptions)[number]

export interface AvailableRooms {
  rooms: Record<string, Room> | null
  roomTypes: Record<string, AvailableRoomType> | null
  ga4Impressions?: ImpressionViewAncillariesItem[]
}

export interface Room {
  roomId: string
  name: string
  description: string
  isFull: boolean
  availableBedsAmount: number
  totalBedsAmount: number
  roomType: string
}

export interface AvailableRoomType {
  type: string
  description: string
  availableRoomsAmount: number
  totalBedsAmount: number
}

export interface UpdateRoomSelectionPayload {
  assignationMethod: RoomSelectionTypeRadioGroupOptions
  name: string | null
  type: string | null
  pinCode?: string
  isNewRoom: boolean | null
  roomId?: string | null
}

export interface NewRoomBeingCreated {
  name: string
  description: string
  availableBedsAmount: number
  totalBedsAmount: number
  type: string
}

export interface UpdateRoomSelectionResponse {
  isValid: boolean
}
